import React, { useEffect, useState } from 'react'

import { AsyncSelect } from '@components/atoms'
import {
  ErrorMessage,
  HelperMessage,
  FieldLabel
} from './AsyncSelectField.styled'
import { isEmpty, omit, uniqBy } from 'lodash'

const EMPTY_OPTIONS = []

const AsyncSelectField = ({
  label,
  name,
  placeholder,
  options = EMPTY_OPTIONS,
  className,
  helperMessage,
  error,
  setPage,
  setFieldValue,
  value: fieldValue,
  ...props
}) => {
  const [accumulatedOptions, setAccumulatedOptions] = useState(() =>
    uniqBy(options, 'value')
  )

  const value = React.useMemo(() => {
    const resolveOption = (selected) => {
      const selectedValue =
        selected && typeof selected === 'object' ? selected.value : selected
      return accumulatedOptions.find(({ value }) => value === selectedValue)
    }

    if (props.isMulti) {
      return (
        fieldValue &&
        fieldValue.map((selected) => resolveOption(selected) || selected)
      )
    }

    if (fieldValue === undefined || fieldValue === null || fieldValue === '') {
      return undefined
    }
    return resolveOption(fieldValue) || { ...fieldValue }
  }, [fieldValue, props.isMulti, accumulatedOptions])

  useEffect(() => {
    setAccumulatedOptions((previousOptions) =>
      uniqBy([...options, ...previousOptions], 'value')
    )
  }, [options])

  return (
    <div className={className}>
      {label && <FieldLabel htmlFor={name}>{label}</FieldLabel>}
      <AsyncSelect
        {...omit(props, ['onChange', 'touched'])}
        name={name}
        placeholder={placeholder}
        error={error}
        setPage={setPage}
        options={accumulatedOptions}
        value={value}
        onChange={(opt) => {
          if (isEmpty(opt)) {
            setFieldValue(name, [])
          } else {
            setFieldValue(name, opt)
          }
        }}
      />
      {error && (
        <ErrorMessage className={`error-text ${error ? 'input-error' : ''}`}>
          {error}
        </ErrorMessage>
      )}
      {helperMessage && (
        <HelperMessage className="helper-text">{helperMessage}</HelperMessage>
      )}
    </div>
  )
}

export default AsyncSelectField
